import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {AngularFireAuth} from 'angularfire2/auth';
import * as firebase from 'firebase/app';

import {Router} from '@angular/router';
import {AngularFireDatabase, FirebaseListObservable} from 'angularfire2/database';


@Injectable()
export class AuthService {
  loginInfo = null;
  loginerror = '';
  signuperror = '';
  users: FirebaseListObservable<any>;
  user: Observable<firebase.User>;
  constructor(private firebaseAuth: AngularFireAuth, db: AngularFireDatabase) {
    this.user = firebaseAuth.authState;
    this.users = db.list('/users');
    this.user.subscribe((auth) => {
      this.loginInfo = auth
    });
  }
  //function to signup to the firebase authentication
  signup(email: string, password: string, name: object) {
    this.firebaseAuth
      .auth
      .createUserWithEmailAndPassword(email, password)
      .then(value => {
        console.log('Success!', value);
        this.firebaseAuth.auth.currentUser.sendEmailVerification();
        this.users.push({email: email,
          uid: this.firebaseAuth.auth.currentUser.uid,
          name});
      })
      .catch(err => {
        console.log('Something went wrong:', err.message);
        this.signuperror = err.message;
      });
  }
  //function to login to the firebase authentication
  login(email: string, password: string) {
    //makes it so that when they close the tab it logs them out
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
  .then(function() {
    // Existing and future Auth states are now persisted in the current
    // session only. Closing the window would clear any existing state even
    // if a user forgets to sign out.
    // ...
    // New sign-in will be persisted with session persistence.
    return firebase.auth().signInWithEmailAndPassword(email, password);
  })
  .catch(function(error) {
    // Handle Errors here.
    var errorCode = error.code;
    var errorMessage = error.message;
  });
    /*this.firebaseAuth
      .auth
      .signInWithEmailAndPassword(email, password)
      .then(value => {
        console.log('Nice, it worked!' , value);
      })
      .catch(err => {
        console.log('Something went wrong:', err.message);
        this.loginerror = err.message;
      }); */
  }
  //logs the user out of the firebase authentication
  logout() {
    this.firebaseAuth
      .auth
      .signOut()
      .then(value => {
        console.log('Nice, it logged out' , value)
      })
      .catch(err => {
        console.log('Something went wrong:',err.message);
      });
  }

}/**
 * Created by Eiston on 7/5/2017.
 */



// WEBPACK FOOTER //
// ./src/app/auth/auth.service.ts